
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'Loader' })
export default class Loader extends Vue {
  @Prop({ default: false }) darkMode: boolean;
}
